import React from 'react'

export const Header = () => {
    return (
        <header>
            <h1>Enjoy the best music releases of 2019</h1>
        </header>
    )
}

